export default () => {
    return {
        restrict: 'E',
        template: '<input type="number" ng-max="{{numPages}}" ng-model-options="{debounce: 500}" class="form-control" ng-model="inputPage" ng-change="selectPage(inputPage)">',
        link: function (scope, element, attrs) {
            scope.$watch('currentPage', function (c) {
                scope.inputPage = c;
            });
        }
    }
};
